import { calculateDeliveryProposalOfferCargoStatus } from "@/features/offer-cargo-process-status";
import {
  type DELIVERY_PROPOSAL_CONTRACT_STATUS,
  calculateDeliveryProposalContractStatus,
} from "@/features/offer-cargo-process-status/badge-status";
import { calculateDeliveryProposalResponseDeadlineAt } from "@/features/offer-cargo-process-status/delivery-proposal-response-deadline-at";
import type { ShipperCargoDetailPageProps } from "@/pages/shipper-cargo-detail/model";
import {
  fromIso8601DateTime,
  toLocaleTextAsDateTime,
} from "@/shared/lib/datetime";

export type DeliveryProposalTableDataType = {
  id: number;
  companyName: string;
  deliveryProposalContractStatus: DELIVERY_PROPOSAL_CONTRACT_STATUS;
  proposedAt: string;
  responseDeadlineAt: Date;
  requiredShippingFee: number;
  proposedFeeDiff: number | undefined;
};

export const getDraftOfferCargoRows = (
  offerCargoProcess: ShipperCargoDetailPageProps["offerCargoProcess"],
) => {
  if (offerCargoProcess.status !== "success") {
    return [];
  }
  return offerCargoProcess.data.deliveryProposalOfferCargos.map<DeliveryProposalTableDataType>(
    (deliveryProposalOfferCargo) => {
      const responseDeadlineAt = calculateDeliveryProposalResponseDeadlineAt(
        deliveryProposalOfferCargo,
      );
      const deliveryProposalOfferCargoStatus =
        calculateDeliveryProposalOfferCargoStatus({
          deliveryProposalOfferCargoId: deliveryProposalOfferCargo.id,
          process: offerCargoProcess.data,
        });
      const deliveryProposalContractStatus: DELIVERY_PROPOSAL_CONTRACT_STATUS =
        calculateDeliveryProposalContractStatus({
          viewer: "shipper",
          status: deliveryProposalOfferCargoStatus,
        });
      return {
        id: deliveryProposalOfferCargo.id,
        companyName: deliveryProposalOfferCargo.company?.name ?? "",
        deliveryProposalContractStatus: deliveryProposalContractStatus,
        responseDeadlineAt,
        proposedAt: toLocaleTextAsDateTime(
          fromIso8601DateTime(deliveryProposalOfferCargo.createdAt),
        ),
        requiredShippingFee: deliveryProposalOfferCargo.shippingFee,
        proposedFeeDiff:
          offerCargoProcess.data.draftOfferCargo.shippingFee === 0
            ? undefined
            : deliveryProposalOfferCargo.shippingFee -
              offerCargoProcess.data.draftOfferCargo.shippingFee,
      };
    },
  );
};
